<template>
    <div class="organization-account" id="coin-record">
        <el-container>
            <el-aside width="270px" :style="{ height: asideHeight + 'px' }">
                <aside-bar :treeDataList="treeData" @choose="choseOrganization" :loading="treeLoading" :asideHeight="asideHeight"></aside-bar>
            </el-aside>
            <el-main>
                <!-- <div class="account-header">
          <span class="label">選擇：</span>
          <el-select v-model="currentSelected" placeholder="请选择">
            <el-option :key="1" label="組別" :value="1"></el-option>
            <el-option :key="2" label="員工" :value="2"></el-option>
          </el-select>
        </div>-->
                <div class="classify-tab">
                    <span :class="{ active: currentSelected === 2 }" @click="currentSelected = 2">員工</span>
                    <span class="line"></span>
                    <span :class="{ active: currentSelected === 1 }" @click="currentSelected = 1">組別</span>
                </div>
                <div class="tab-content">
                    <div class="container-tissue" v-show="currentSelected === 1">
                        <!-- 当前选中组织数据 -->
                        <div class="table-contain org-table">
                            <el-table :data="selecteddepTableData" empty-text="暫無數據" v-loading="selectDepLoading">
                                <el-table-column prop="departmentName" label="組別" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="remainderPropertyCoin" label="金幣數量" :width="13 * 10" v-if="isShowCoinHistory" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="remainderDiamond" label="鑽石數量" :width="13 * 10" v-if="isShowDiamondHistory" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="status" label="組別狀態" :width="13 * 6" show-overflow-tooltip>
                                    <template slot-scope="scope">{{ scope.row.status | statusTransition }}</template>
                                </el-table-column>
                                <el-table-column label="查看記錄" :width="13 * 9" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="goToDetail(scope.row.departmentID, scope.row.departmentName, 'department')">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- 組別查詢 -->
                        <div class="search-condition-tissue mt-5">
                            <el-select v-model="status" placeholder="組別狀態">
                                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-button type="danger" @click="departmentSearch">搜尋</el-button>
                            <el-button type="info" @click="departmentReset">重置</el-button>
                            <button class="hoverButton" @click="depExc('dep')">導出</button>
                        </div>
                        <!-- 組別 -->
                        <div class="table-contain">
                            <el-table :data="tableData" empty-text="暫無數據" v-loading="selectDepLoading">
                                <el-table-column prop="departmentName" label="組別"></el-table-column>
                                <el-table-column prop="remainderPropertyCoin" label="金幣數量" :width="13 * 10" show-overflow-tooltip v-if="isShowCoinHistory"></el-table-column>
                                <el-table-column prop="remainderDiamond" label="鑽石數量" :width="13 * 10" show-overflow-tooltip v-if="isShowDiamondHistory"></el-table-column>
                                <el-table-column prop="status" label="組別狀態" :width="13 * 6" show-overflow-tooltip>
                                    <template slot-scope="scope">{{ scope.row.status | statusTransition }}</template>
                                </el-table-column>
                                <el-table-column label="查看記錄" :width="13 * 9" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="goToDetail(scope.row.departmentID, scope.row.departmentName, 'department')">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination clearfix">
                                <div class="count" v-if="false">
                                    <span>當前查詢記錄：{{ departmentTotal }}</span>
                                    <span>總記錄：{{ departmentTotalCount }}</span>
                                </div>
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="departmentPageIndex" :page-size="departmentPageCount" layout="total,sizes,prev,pager,next,jumper" :total="departmentTotal"></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="container-staff" v-show="currentSelected === 2">
                        <!-- 員工查詢 -->
                        <div class="search-condition-staff">
                            <el-select v-model="roleId" placeholder="角色">
                                <el-option v-for="item in roleOptions" :key="item.roleID" :label="item.roleName" :value="item.roleID"></el-option>
                            </el-select>
                            <el-select v-model="staffStatus" placeholder="員工狀態">
                                <el-option v-for="item in staffStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-input v-model="staffName" placeholder="員工姓名搜尋"></el-input>
                            <el-button type="danger" @click="staffSearch" class="ml-25">搜尋</el-button>
                            <el-button type="info" @click="staffReset">重置</el-button>
                            <button class="hoverButton" @click="depExc('staff')">導出</button>
                        </div>
                        <!-- 員工表格 -->
                        <div class="table-contain">
                            <el-table :data="staffTableData" style="width: 100%" empty-text="暫無數據" v-loading="staffLoading">
                                <el-table-column label="員工名稱" :width="13 * 14">
                                    <template slot-scope="scope">{{ scope.row.name ? scope.row.name : '-' }}</template>
                                </el-table-column>
                                <el-table-column prop="departmentName" label="所屬組別"></el-table-column>
                                <el-table-column prop="remainderPropertyCoin" label="金幣數量" :width="13 * 10" v-if="isShowCoinHistory" show-overflow-tooltip>
                                    <template slot-scope="scope">{{ scope.row.remainderPropertyCoin }}</template>
                                </el-table-column>
                                <el-table-column prop="remainderDiamond" label="鑽石數量" :width="13 * 10" v-if="isShowDiamondHistory" show-overflow-tooltip></el-table-column>
                                <el-table-column label="員工角色" :width="13 * 8" show-overflow-tooltip>
                                    <template slot-scope="scope">{{ roleTransition[scope.row.roleID] }}</template>
                                </el-table-column>
                                <el-table-column label="員工狀態" :width="13 * 6" show-overflow-tooltip>
                                    <template slot-scope="scope">{{ scope.row.status | statusTransition }}</template>
                                </el-table-column>
                                <el-table-column label="操作" :width="13 * 9" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="goToDetail(scope.row.departmentID, scope.row.name, 'staff', scope.row.accountID)">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination clearfix">
                                <div class="count" v-if="false">
                                    <span>當前查詢記錄：{{ staffTotal }}</span>
                                    <span>總記錄：{{ staffTotalCount }}</span>
                                </div>
                                <el-pagination background @size-change="handleStaffSizeChange" @current-change="handleStaffCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="staffPageCount" :current-page="staffPageIndex" layout="total,sizes,prev, pager,next, jumper" :total="staffTotal"></el-pagination>
                            </div>
                        </div>
                    </div>
                    <!--导出excel -->
                    <el-dialog title="選擇導出日期" :visible.sync="dialogVisible" width="30%">
                        <div class="dateAll">
                            <span>時間範圍：&nbsp;&nbsp;</span>
                            <span class="dateSel">
                                <el-radio-group v-model="checkedCities" :max="1">
                                    <el-radio v-for="item in checkDate" :label="item" :key="item" @change="dateChange">{{ item }}</el-radio>
                                </el-radio-group>
                            </span>
                        </div>
                        <div>
                            <span>選擇日期：&nbsp;&nbsp;</span>
                            <span class="block">
                                <span>
                                    <!-- <el-date-picker 
                                    v-model="value1" 
                                    type="daterange" 
                                    align="right" 
                                    unlink-panels 
                                    range-separator="至" 
                                    start-placeholder="开始日期" 
                                    end-placeholder="结束日期" > 
                                    </el-date-picker> -->
                                    <!-- [0] -->
                                    <el-date-picker v-model="value1" :disabled="checkedCities == '自訂日期' ? false : true" type="daterange" range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" style="width: 250px" value-format="timestamp"> </el-date-picker>
                                    <p v-if="warnShow" class="selDat">請選擇日期</p>
                                </span>
                            </span>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <!-- checkedCities.length == 0 -->
                            <el-button type="primary" @click="downloadExl" :disabled="checkedCities == '' || checkedCities == undefined || checkedCities == null">確 認</el-button>
                        </span>
                    </el-dialog>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
// import asideBar from "../components/asideBar.vue";
import asideBar from '../../org_manage/components/asideBar.vue';
import mixin from '../mixins/index';
import calcAsideHeight from '../mixins/calcAsideHeight';
import { mapGetters } from 'vuex';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'OraganizationAccount',
    components: {
        asideBar
    },
    mixins: [mixin, calcAsideHeight],
    data() {
        return {
            tableDatas: [],
            value1: [],
            checkDate: ['全部', '自訂日期'],
            checkedCities: '全部',
            dialogVisible: false,
            warnShow: false,
            fromDep: false,
            isUsedDiamond: false,
            isUsedCoin: false,
            isShowCoinHistory: false,
            isShowDiamondHistory: false,
            currentSelected: 2, // 1表示組別，2表示員工

            departmentId: 0, //当前用户组织id
            selecteddepTableData: [], //当前选中组织数据
            selectDepLoading: false,
            // statusOptions: [],
            // status: "",
            // treeData: [],
            // tableData: [],
            // departmentPageIndex: 1,
            // departmentPageCount: 5,
            // departmentTotal: 0,
            // departmentTotalCount: 0,

            //  員工相關數據
            // roleOptions: [],
            // role: "",
            // staffStatusOptions: [],
            // staffStatus: "",
            staffName: ''
            // staffTableData: [],
            // staffTotal: 0,
            // staffTotalCount: 0,
            // staffPageIndex: 1,
            // staffPageCount: 10
        };
    },
    async created() {
        this.getCompanyCofig();
        this.parentId = this.userInfo.departmentID || (await this.getUserInfo());
        this.departmentId = this.parentId;
        this.getDepartmentsTree();
        // this.getDepartments();
        this.getDepartmentById(this.parentId);
        if (this.currentSelected === 1) {
            this.departmentPageCount = this.pub.getPageSize(this.userInfo.accountID, 'mcoinRePageCount') || 10;
            this.getDepartments();
        } else {
            this.staffPageCount = this.pub.getPageSize(this.userInfo.accountID, 'pcoinRePageCount') || 10;
            this.searchCompanyUserInfo();
        }
    },
    methods: {
        dateChange() {
            if (this.checkedCities !== '自訂日期') {
                this.value1 = [];
            }
        },
        repeatDow(res, loading) {
            this.tableDatas = [];
            let excelTxt = '';
            if (this.isUsedDiamond && this.isUsedCoin) {
                excelTxt = '金幣/鑽石';
            } else if (this.isUsedCoin) {
                excelTxt = '金幣';
            } else {
                excelTxt = '鑽石';
            }
            if (res.data.code == 0) {
                for (let i = 0; i < res.data.result.userRecord.length; i++) {
                    this.tableDatas.push(res.data.result.userRecord[i]);
                }
                if (!this.tableDatas) return;
                const wb = XLSX.utils.book_new();
                const map = {};
                for (let z = 0; z < this.tableDatas.length; z++) {
                    var arr = [];
                    // 禁用 eval
                    if (this.fromDep) {
                        // 重名加序号
                        map[this.tableDatas[z].departmentName] = map[this.tableDatas[z].departmentName] == null ? 0 : map[this.tableDatas[z].departmentName] + 1;
                        map[this.tableDatas[z].departmentName] && (this.tableDatas[z].departmentName += map[this.tableDatas[z].departmentName]);
                        this.tableDatas[z].record.map(item => {
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.organizationCoinTransWithCulture;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            if (this.isUsedDiamond && this.isUsedCoin) {
                                obj.金幣 = parseInt(item.propertyCoin);
                                obj.鑽石 = parseInt(item.diamond);
                            } else if (this.isUsedCoin) {
                                obj.金幣 = parseInt(item.propertyCoin);
                            } else {
                                obj.鑽石 = parseInt(item.diamond);
                            }
                            obj.操作人 = item.operatorName;
                            arr.push(obj);
                        });
                    } else {
                        map[this.tableDatas[z].name] = map[this.tableDatas[z].name] == null ? 0 : map[this.tableDatas[z].name] + 1;
                        map[this.tableDatas[z].name] && (this.tableDatas[z].name += map[this.tableDatas[z].name]);
                        this.tableDatas[z].record.map(item => {
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.userCoinRecordWithCulture;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            if (this.isUsedDiamond && this.isUsedCoin) {
                                obj.金幣 = parseInt(item.propertyCoin);
                                obj.鑽石 = parseInt(item.diamond);
                            } else if (this.isUsedCoin) {
                                obj.金幣 = parseInt(item.propertyCoin);
                            } else {
                                obj.鑽石 = parseInt(item.diamond);
                            }
                            obj.操作人 = item.operatorName;
                            arr.push(obj);
                        });
                    }
                    if (this.isUsedDiamond && this.isUsedCoin) {
                        var header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '金幣', '鑽石', '操作人'] };
                    } else if (this.isUsedCoin) {
                        var header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '金幣', '操作人'] };
                    } else {
                        var header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '鑽石', '操作人'] };
                    }
                    try {
                        const ws = XLSX.utils.json_to_sheet(arr, header);
                        // JSON.stringify()${z + 1}、
                        if (this.fromDep) {
                            XLSX.utils.book_append_sheet(wb, ws, `${this.tableDatas[z].departmentName.slice(0, 31)}`);
                        } else {
                            XLSX.utils.book_append_sheet(wb, ws, `${this.tableDatas[z].name.slice(0, 31)}`);
                        }
                    } catch (error) {
                        this.$message({
                            message: `${error}`,
                            type: 'error',
                            showClose: true
                        });
                    }
                }
                try {
                    XLSX.writeFile(wb, `${this.selecteddepTableData[0].departmentName}${excelTxt}記錄.xlsx`);
                } catch (error) {
                    this.$message({
                            message:`${error}`,
                            type: 'error',
                            showClose: true
                        });
                }
                loading.close();
            } else {
                loading.close();
                this.$message({
                    message: `未有${excelTxt}記錄可導出`,
                    type: 'error',
                    showClose: true
                });
            }
        },
        downloadExl() {
            // 如果选择自订日期且没有填写日期
            if (this.checkedCities == '自訂日期' && this.value1.length == 0) {
                this.warnShow = true;
                this.dialogVisible = true;
                return;
            } else if (this.checkedCities == '全部' || (this.checkedCities == '自訂日期' && this.value1.length !== 0)) {
                this.warnShow = false;
                this.dialogVisible = false;
            }
            const loading = this.$loading({
                lock: true,
                text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // * 弹出弹框
            this.dialogVisible = false;
            // AllDepCoinDiamond 全部组别
            if (!this.fromDep) {
                this.axios
                    .post(this.pub.getApi().AllUserCoinDiamond, {
                        // 时间戳和组别
                        departmentID: this.departmentId,
                        startTime: this.value1 ? this.value1[0] / 1000 : '',
                        endTime: this.value1 ? this.value1[1] / 1000 : ''
                    })
                    .then(res => {
                        this.repeatDow(res, loading);
                    });
            } else {
                this.axios
                    .post(this.pub.getApi().AllDepCoinDiamond, {
                        departmentID: this.departmentId,
                        startTime: this.value1 ? this.value1[0] / 1000 : '',
                        endTime: this.value1 ? this.value1[1] / 1000 : ''
                    })
                    .then(res => {
                        this.repeatDow(res, loading);
                    });
            }
        },
        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    // this.isProhibitBuyCoin = res.data.result.isProhibitBuyCoin;
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    this.isUsedCoin = res.data.result.isUsedCoin;

                    this.isShowCoinHistory = res.data.result.isShowCoinHistory;
                    this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                }
            });
        },
        // 选择组织
        choseOrganization(data) {
            // console.log(data);
            this.departmentId = data.departmentID;
            this.getDepartmentById(this.departmentId);
            if (this.currentSelected === 1) {
                this.departmentPageIndex = 1;
                this.getDepartments();
            } else {
                this.staffPageIndex = 1;
                this.searchCompanyUserInfo();
            }
        },
        // 组织查询
        departmentSearch() {
            this.departmentPageIndex = 1;
            let data = {};
            if (this.status) data.status = this.status;
            this.getDepartments(data);
        },
        depExc(type) {
            this.checkedCities = '';
            this.dialogVisible = true;
            this.value1 = [];
            this.checkedCities = '全部';
            this.warnShow = false;
            if (type == 'dep') {
                // 组别导出
                this.fromDep = true;
            } else {
                this.fromDep = false;
            }
        },
        // 组织重置
        departmentReset() {
            this.status = '';
            this.departmentPageIndex = 1;
            this.getDepartments();
        },
        goToDetail(departmentId, name, type, accountId) {
            let data = {};
            data.departmentId = departmentId;
            data.name = name;
            data.type = type;
            if (accountId) {
                data.accountId = accountId;
            }
            this.$router.push({
                path: '/coin/record/detail',
                query: data
            });
        },
        // 查询单个组织
        async getDepartmentById(departmentID) {
            this.selectDepLoading = true;
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID
                }
            });
            let { code, result, message } = res.data;
            // console.log(res);
            this.selectDepLoading = false;
            if (code === 0) {
                this.selecteddepTableData = [result];
                // this.selectedDepartment = result;
                // console.log(this.selectedDepartment);
            }
        },
        // 员工页码改变
        // handleStaffSizeChange(val) {
        //   this.staffPageCount = val;
        //   this.staffPageIndex = 1;
        //   this.searchCompanyUserInfo();
        // },
        // // 处理当前页面
        // handleStaffCurrentChange(val) {
        //   this.staffPageIndex = val;
        //   this.searchCompanyUserInfo();
        // },
        // 员工查询
        staffSearch() {
            this.staffPageIndex = 1;
            let data = {};
            if (this.staffStatus) data.status = this.staffStatus;
            if (this.staffName) data.searchName = this.staffName;
            if (this.roleId) data.roleId = this.roleId;
            this.searchCompanyUserInfo(data);
        },
        staffReset() {
            this.roleId = '';
            this.staffStatus = '';
            this.staffName = '';
            this.staffPageIndex = 1;
            this.searchCompanyUserInfo();
        }
    },
    watch: {
        currentSelected(val) {
            // this.selectedTableTr = [];
            if (val === 1) {
                this.departmentPageCount = this.pub.getPageSize(this.userInfo.accountID, 'mcoinRePageCount') || 10;
                this.getDepartments();
            } else {
                this.staffPageCount = this.pub.getPageSize(this.userInfo.accountID, 'pcoinRePageCount') || 10;
                this.searchCompanyUserInfo();
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/element-reset.less';
.organization-account {
    .hoverButton {
        width: 88px;
        margin-left: 10px;
        margin-top: 10px;
        border-radius: 10px;
        height: 38px;
        background-color: rgb(187 187 187);
        border-color: transparent;
        color: rgb(255 255 255);
        cursor: pointer;
    }
    .hoverButton:hover {
        color: rgb(255 255 255);
        background-color: rgb(0 100 255);
    }
    // min-height: 100%;
    .el-aside {
        background: #ffffff;
        border-radius: 10px;
    }
    .el-main {
        padding: 0px;
        margin-left: 20px;
        border-radius: 10px;
        // background: #fafcfe;
        .classify-tab {
            span {
                // display: inline-block;
                // width: 140px;
                // height: 49px;
                // text-align: center;
                // line-height: 49px;
                font-size: 22px;
                color: #999999;
                cursor: pointer;
                &.active {
                    // background-color: #fff;
                    color: #000000;
                }
            }
            .line {
                display: inline-block;
                width: 1px;
                height: 22px;
                margin: 0 22px;
                background-color: #999999;
                position: relative;
                top: 3px;
            }
        }
        .tab-content {
            // padding: 0px 20px 33px;
            margin-top: 10px;
        }
        // 信息分類
        .account-header {
            padding-bottom: 20px;
            // border-bottom: 1px solid @border-grey-color;
            // .label {
            //   color: #92929d;
            //   font-size: 18px;
            // }
            // .el-select {
            //   width: 80px;
            //   /deep/.el-input {
            //     .el-input__inner {
            //       background-color: transparent;
            //       border: none;
            //       color: #171725;
            //       font-size: 18px;
            //       line-height: 25px;
            //       height: 25px;
            //     }
            //     .el-input__suffix {
            //       .el-input__icon {
            //         line-height: 25px;
            //       }
            //     }
            //   }
            // }
        }
        // 查詢條件
        .search-condition-tissue,
        .search-condition-staff {
            .el-select {
                width: 120px;
                margin-right: 15px;
                margin-top: 10px;
                /deep/.el-input__inner {
                    background: #ffffff;
                    border-radius: 10px;
                    height: 38px;
                    line-height: 38px;
                    border: none;
                }
            }
            .el-input {
                width: 150px;
                /deep/.el-input__inner {
                    background: #ffffff;
                    border-radius: 10px;
                    height: 38px;
                    line-height: 38px;
                    border: none;
                }
            }
            .el-input + .el-input {
                margin-right: 15px;
                margin-top: 10px;
            }
            .el-input + span {
                margin-right: 10px;
                margin-left: 10px;
            }
            .el-button {
                width: 88px;
                margin-left: 10px;
                margin-top: 10px;
                border-radius: 10px;
                height: 38px;
            }
            .ml-25 {
                margin-left: 25px;
            }
        }
        .dateAll {
            margin-bottom: 20px;
            .dateSel {
                position: absolute;
            }
        }
        .selDat {
            color: red;
            margin-left: 80px;
        }
        // 數據列表
        .table-contain {
            border-radius: 10px;
            padding: 15px 20px;
            background-color: #fff;
            margin-top: 20px;
            .pagination {
                // text-align: center;
                margin-top: 20px;
                line-height: 35px;
                .count {
                    float: left;
                    span ~ span {
                        margin-left: 10px;
                    }
                }
                .el-pagination {
                    float: right;
                }
            }
            &.org-table {
                .el-table {
                    /deep/.el-table__row > td {
                        border: none;
                    }
                    &::before {
                        height: 0;
                    }
                }
            }
        }
    }
    // 弹框
    .assign-dialog {
        .el-input {
            width: 320px;
        }
    }
    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .clearfix {
        /* 触发 hasLayout */
        zoom: 1;
    }
    .mt-5 {
        margin-top: 5px;
    }
}
</style>
